import { saveAs } from 'file-saver';
export function saveText(name, text, type) {
    var blob = new Blob([text], { type: "".concat(type, ";charset=utf-8") });
    saveAs(blob, name);
}
export function saveCanvas(name, canvas, type) {
    if (type === void 0) { type = 'image/png'; }
    canvas.toBlob(function (blob) {
        saveAs(blob, name);
    }, type);
}
